import type { CreateDialogStepName, Tag, TagToCreate } from '../types';
import type { RootState } from '../configuration/setup/store';
import { getUserAccount } from '../configuration/login/loginSlice';
import { tagsApi } from './app/services/tagsApi';

// =============================
// USER
// =============================
export function getShowDeleteUserDialog(state: RootState) {
    return state.user.userDeletionDialog.showDialog;
}
export function getUsersToDelete(state: RootState) {
    return state.user.userDeletionDialog.usersToDelete;
}
export function getShowUserCreation(state: RootState): boolean {
    return state.user.userDialog.showDialog;
}
export function getUserCreationStep(state: RootState): CreateDialogStepName {
    return state.user.userDialog.currentStep;
}

// =============================
// GROUPS
// =============================
export function getAllTagsInAccount(state: RootState): Tag[] {
    const accountId = getUserAccount(state);
    if (!accountId) {
        return state.groups.allTagsInAccount;
    }

    return tagsApi.endpoints.getTags.select(accountId)(state).data ?? state.groups.allTagsInAccount;
}
export function isFetchTagsInProgressRtk(state: RootState): boolean {
    const accountId = getUserAccount(state);
    if (!accountId) {
        return state.groups.fetchTagsRequested;
    }

    const query = tagsApi.endpoints.getTags.select(accountId)(state);
    return query.isUninitialized ? state.groups.fetchTagsRequested : query.isLoading;
}
export function getTagsToCreate(state: RootState): TagToCreate[] {
    return state.groups.tagsToCreate;
}
export function getTagsToAdd(state: RootState): Tag[] {
    return state.groups.tagsToAdd;
}
export function getTagsToRemove(state: RootState): Tag[] {
    return state.groups.tagsToRemove;
}
export function getMultiSelectTagsToCreate(state: RootState): TagToCreate[] {
    return state.groups.multiSelect.tagsToCreate;
}
export function getMultiSelectTagsToAdd(state: RootState): Tag[] {
    return state.groups.multiSelect.tagsToAdd;
}
export function getMultiSelectTagsToRemove(state: RootState): Tag[] {
    return state.groups.multiSelect.tagsToRemove;
}
